import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) return setError("Reset link is missing or invalid.");
    if (pw.length < 6) return setError("Password must be at least 6 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-6">
        <div className="inline-flex w-14 h-14 rounded-md bg-brand items-center justify-center mb-4">
          <ShieldCheck className="w-7 h-7 text-white" strokeWidth={2.4} />
        </div>
        <h1 className="text-3xl font-outfit font-bold text-white">Choose a new password</h1>
      </div>

      {done ? (
        <div className="card-flat p-6 text-center space-y-2">
          <div className="font-outfit font-semibold text-white">Password updated</div>
          <p className="text-sm text-white/60 font-manrope">Redirecting you to login…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="card-flat p-6 space-y-4">
          <div>
            <Label className="font-manrope">New password</Label>
            <Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw" />
          </div>
          <div>
            <Label className="font-manrope">Confirm password</Label>
            <Input type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2" />
          </div>
          {error && <div className="text-sm text-red-600 font-manrope">{error}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-brand hover:bg-brand-hover text-white py-6 font-manrope font-semibold" data-testid="reset-submit">
            {busy ? "Updating…" : "Update password"}
          </Button>
          <div className="text-center text-sm text-white/70 font-manrope">
            <Link to="/login" className="text-brand font-semibold">Back to login</Link>
          </div>
        </form>
      )}
    </div>
  );
}
